import { Link } from 'react-router-dom';
import { movies } from '@/mocks/movies';
import MovieCard from '@/components/base/MovieCard';

export default function LatestMoviesSection() {
  const latestMovies = movies.filter((m) => m.isNew).slice(0, 8);
  const displayMovies = latestMovies.length > 0 ? latestMovies : movies.slice(0, 8);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">最新上映</h2>
            <p className="text-xs md:text-sm text-foreground-400 mt-1">第一时间更新，不错过任何好片</p>
          </div>
          <Link
            to="/category/dongzuo"
            className="flex items-center gap-1 text-sm text-primary-400 hover:text-primary-300 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop>
          {displayMovies.map((movie) => (
            <MovieCard key={movie.id} {...movie} />
          ))}
        </div>
      </div>
    </section>
  );
}